import {Component, OnInit} from '@angular/core';

import {ParametersService, SubtitlesService, ZonesService} from "../../core";
import {StateService} from "@uirouter/core";

@Component({
    selector: 'zone-container-info',
    templateUrl: './zone-container-info.component.html',
    styleUrls: ['./zone-container-info.component.scss']
})
export class ZoneContainerInfoComponent implements OnInit {
    constructor(
        private parameters: ParametersService,
        private $state: StateService,
        private subtitles: SubtitlesService,
        public zones: ZonesService,
    ) {
    }

    ngOnInit() {
        if (this.zones.selectedContainer === null) {
            this.$state.go('home', {selectedModuleHash: this.parameters.selectedModuleHash});
            return;
        }
        this.zones.setOverflow();
    }

    subtitle(id: number) {
        return this.subtitles.setSubtitle(id);
    }
}
